/* House of Vanika — header state, scroll reveals, mobile menu, mobile gallery dots. No dependencies. */
(function () {
  var doc = document.documentElement;
  doc.classList.add('hov-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header: ivory at top, loom green once the page scrolls (with hysteresis so it never flickers). */
  function initHeader() {
    var header = document.querySelector('[data-hov-header]');
    if (!header) return;
    /* A zero-height sentinel at the top of the page: once it leaves the viewport, the page has scrolled.
       Works whether the window or an inner element scrolls (e.g. the theme editor preview). */
    var sentinel = document.querySelector('[data-hov-sentinel]');
    var group = document.getElementById('header-group');
    var host = (group && group.parentElement) || document.body;
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.setAttribute('data-hov-sentinel', '');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:relative;height:96px;margin-bottom:-96px;width:1px;pointer-events:none;visibility:hidden;';
      host.insertBefore(sentinel, host.firstChild);
    }
    function set(on) { header.classList.toggle('is-scrolled', on); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { set(!e[0].isIntersecting); }).observe(sentinel);
    }
    /* Backup: catch scrolling on the window or on any scrolling container. */
    document.addEventListener('scroll', function (e) {
      var t = e.target, y = window.scrollY || 0;
      if (t && t !== document && t.scrollTop) y = Math.max(y, t.scrollTop);
      set(y > 80 || sentinel.getBoundingClientRect().bottom < 0);
    }, { capture: true, passive: true });

    var toggle = header.querySelector('[data-hov-menu-toggle]');
    var drawer = document.querySelector('[data-hov-drawer]');
    if (toggle && drawer) {
      function setOpen(open) {
        drawer.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open);
        document.body.style.overflow = open ? 'hidden' : '';
        if (open) { var f = drawer.querySelector('a, button'); if (f) f.focus(); } else { toggle.focus(); }
      }
      toggle.addEventListener('click', function () { setOpen(!drawer.classList.contains('is-open')); });
      drawer.querySelectorAll('[data-hov-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });
    }
  }

  /* Reveal on scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-hov-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    /* Safety: never leave content hidden */
    setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 1800);
  }

  /* Mobile gallery: dots follow the swipe position */
  function initGallery() {
    document.querySelectorAll('[data-hov-gallery]').forEach(function (g) {
      var dots = g.parentElement.querySelectorAll('[data-hov-dot]');
      if (!dots.length) return;
      g.addEventListener('scroll', function () {
        var i = Math.round(g.scrollLeft / (g.firstElementChild.getBoundingClientRect().width || 1));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
    });
  }

  function init() { initHeader(); initReveal(); initGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initGallery(); initHeader(); });
})();
